import styled from '@emotion/styled';
import { InputNumber } from 'antd';

export const StyledFormInputNumber = styled(InputNumber)`
  width: 100%;
  height: 40px !important;
  font-size: 16px;
  line-height: 40px;
`;
